export interface GlobalProgressState {
  id: string;
  createdDate: string;
  lastModifiedDate: string;
  userId: string;
  courseComplete: Array<string>;
  courseInProgress: Array<string>;
  enrollmentRequestedCourses: Array<string>;
  progressTrackers: Array<string>;
  inactiveCourses: Array<string>;
  courseStates: Array<string>;
  applicationInDraft: Array<string>;
  courseEnrolled: Array<string>;

  applicationAccepted: Array<string>;
  applicationInProgress: Array<string>;
  applicationRejected: Array<string>;
  applicationTimeout: Array<string>;
  programEnrolled: Array<string>;
  programPause: Array<string>;
  examReviewInProgress: Array<string>;
}

export interface CourseProgressUpdateState {
  courseId: string;
  courseProgressPercentage: string;
}

export const GlobalProgressInitialState: GlobalProgressState = {
  id: '',
  createdDate: '',
  lastModifiedDate: '',
  userId: '',
  applicationInDraft: [],
  courseComplete: [],
  enrollmentRequestedCourses: [],
  courseInProgress: [],
  progressTrackers: [],
  inactiveCourses: [],
  courseStates: [],
  examReviewInProgress: [],
  /* courseEnrolled: [],
  applicationAccepted: [], */
  courseEnrolled: [],
  applicationAccepted: [],
  applicationInProgress: [],
  applicationTimeout: [],

  applicationRejected: [],

  programPause: [],
  programEnrolled: []



};
